import React from 'react';
import styled from 'styled-components';

const IconWrapper = styled.div`
  font-family: 'Press Start 2P', monospace;
  font-size: ${props => props.size || '16px'};
  color: ${props => props.color || 'inherit'};
  transform: scale(var(--pixel-scale));
  image-rendering: pixelated;
  
  &.hover-effect:hover {
    --pixel-scale: 1.1;
  }
`;

const pixelIcons = {
  notepad: '📝',
  cmd: '💻',
  resume: '📄',
  portfolio: '🎨',
  chess: '♟️',
  about: 'ℹ️',
  recycle: '🗑️',
  volume: '🔊',
  volumeLow: '🔉',
  volumeMute: '🔇',
  battery: '🔋',
  batteryLow: '🪫',
  charging: '⚡',
  network: '📶',
  // Add more pixel art versions of icons
};

export const PixelIcon = ({ icon, size, color, className }) => (
  <IconWrapper 
    size={size} 
    color={color} 
    className={`hover-effect ${className || ''}`}
  >
    {pixelIcons[icon] || icon}
  </IconWrapper>
); 